module.exports = __webpack_public_path__ + "static/media/Helvetica-Bold-01.0eea9386.svg";